// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"491e3546","240":"25c380c9","241":"69d05b7a","300":"0586488c","505":"510da904","696":"d58c75ee","805":"ba0ca4be","885":"609a0194","996":"ebddaddd"}[chunkId] + ".chunk.js";
};